import { FC, PropsWithChildren } from "react";

import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";

import classes from "./footer.scss";

const HelpCenterArticleFooter: FC<PropsWithChildren> = ({ children }) => {
  return (
    <footer>
      <div className={classes.content}>{children}</div>
      <Button variant="secondary" onClick={() => window.history.back()}>
        {__("Wróć")}
      </Button>
    </footer>
  );
};

export default HelpCenterArticleFooter;
